import React from "react";

const ProfileIcon = (props: any) => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.99967 10.1224C7.63415 10.1224 5.70801 8.19625 5.70801 5.83073C5.70801 3.4652 7.63415 1.53906 9.99967 1.53906C12.3652 1.53906 14.2913 3.4652 14.2913 5.83073C14.2913 8.19625 12.3652 10.1224 9.99967 10.1224ZM9.99967 1.78906C7.77353 1.78906 5.95801 3.60459 5.95801 5.83073C5.95801 8.05687 7.77353 9.8724 9.99967 9.8724C12.2258 9.8724 14.0413 8.05687 14.0413 5.83073C14.0413 3.60459 12.2258 1.78906 9.99967 1.78906Z"
        fill="var(--color-btn-primary-active)"
        stroke="var(--color-btn-primary-active)"
      />
      <path
        d="M17.1585 18.4583C17.1283 18.4583 17.097 18.446 17.0714 18.4204C17.0457 18.3948 17.0335 18.3635 17.0335 18.3333C17.0335 15.0821 13.7643 12.625 10.0001 12.625C6.236 12.625 2.9668 15.0821 2.9668 18.3333C2.9668 18.3635 2.95451 18.3948 2.92887 18.4204C2.90322 18.446 2.87194 18.4583 2.8418 18.4583C2.81165 18.4583 2.78037 18.446 2.75473 18.4204C2.72908 18.3948 2.7168 18.3635 2.7168 18.3333C2.7168 15.1343 5.89336 12.375 10.0001 12.375C14.1069 12.375 17.2835 15.1343 17.2835 18.3333C17.2835 18.3635 17.2712 18.3948 17.2455 18.4204C17.2199 18.446 17.1886 18.4583 17.1585 18.4583Z"
        fill="var(--color-btn-primary-active)"
        stroke="var(--color-btn-primary-active)"
      />
    </svg>
  );
};

export default ProfileIcon;
